<template>
  <div>

    <el-dialog :title="title" :visible.sync="show_" @close="hideAlert()">

      <div class="row-no-full search-ma flex-wrap">
        <div class="row-no-full" v-for="(v,i) in query.search.condition" :key='i'>
          <el-input    v-model="v.value" size='small' :placeholder='v.placeholder' ></el-input>
        </div>
        <el-button   size='small' type='primary' style="width: 12.5rem;margin-left: 20px;" @click='submit'>搜索</el-button>
      </div>
      <el-table :data="tableList.data" v-loading='loading'>

        <el-table-column  v-for="(v,i) in label"  :key='i' :property="v.key" :label="v.label"  >

          <template slot-scope="scope">
                                  <!-- 将搜索的值传递出去 -->
            <slot :name="v.key"   v-bind:item='scope.row'>{{getObj(scope.row,v.key) }}</slot>
          </template>

        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size='small' type='primary' @click='selected(scope.row)'>选择</el-button>
          </template>
        </el-table-column>


      </el-table>

      <el-pagination
        style="margin-top: 1.25rem;"
        background
        layout="prev, pager, next"
        @current-change='next'
        :total="tableList.total">
      </el-pagination>

    </el-dialog>


    <div v-if='show_button'>

      <el-button type='primary' @click="showAlertByButton" size='small'>选择</el-button>

    </div>

  </div>
</template>

<script>
  export default {
    name: "Alert",
    data() {
      return {

        show_: this.show,

        query:{

          p:1,
          search:{
            model:"",
            condition:[],
            label:[],
            defaultCondition:[],
            namespace:'',
            with:[]
          }

        },
        tableList:{
          data:[],
          currentPage:1,
          total:0
        },
        loading:false,
        conditionTemplate:{
          field:"",
          condition:"=",
          value:"",
          placeholder:""



        },



      }
    },
    methods: {

      getList(){


        if(this.model==='') return false;

        this.loading=true;
        this.httpPost({
          url:this.url,
          data:this.query
        }).then((re)=>{



          this.tableList=re.data;

          this.$nextTick(()=>{

            this.loading=false;

          });

        });


      },
      next(page){
        this.query.p=page;

        this.getList();

      },
      selected(row){

        this.$emit('selected',row);

        // this.$emit('update:show', false);
        
        if(this.auto_close) this.hideAlert();
        

      },
      submit(){

        this.query.p=1;

        this.getList();

      },
      setCondition(){

        let temp=[];

        for(let i in this.condition){



          temp.push({});


          for(let j in this.conditionTemplate){



            let cosValue=this.condition[i][j];


            if(!cosValue){


              temp[i][j]=this.conditionTemplate[j];

              continue;
            }


            temp[i][j]=cosValue;


          }


        }


        let temp_=this.cloneObj(temp);

        this.query.search.condition=temp_;



      },
      showAlert(){


        // this.show_=true

        // this.getList();
        
        
        if(this.show_button){
          
          
          this.show_=true;
          
        }else{
          
          this.$emit('update:show', true)
          
        }
        

      },
      hideAlert(){
        
        if(this.show_button){
          
          
          this.show_=false;
          
        }else{
          
          this.$emit('update:show', false)
          
        }
        
      },
      showAlertByButton(){
        
        this.showAlert();
        
        this.getList();
        
      }



    },
    created() {

      // console.log('show!!!!!!!!');

      this.query.search.model=this.model;

      this.query.search.label=this.label;

      this.query.search.defaultCondition=this.defaultCondition;

      this.query.search.namespace=this.namespace;

      this.query.search.with=this.with;

      this.setCondition();


      // this.getList();



      // console.log(this.model);

    },
    computed: {



    },
    props: {
      show: {
        type: Boolean,
        default: false
      },

      label:{

        type:Array,
        default:function(){

          return [];
        }
      },
      title:{

        type:String,
        default:"标题"

      },
      url:{

        type:String,
        default:"/admin/search/search"

      },
      model:{
        type:String,
        default:""
      },
      condition:{
        type:Array,
        default:function(){

          return [];
        }
      },
      defaultCondition:{

        type:Array,
        default:function(){


          return []
          // return [{field:'id',condition:'>',value:'1'}]
        }

      },
      //模型的命名空间
      namespace:{

        type:String,
        default:"\App\\Model\\"


      },
      //设置模型关联
      with:{
        type:Array,
        default:function(){

          return [];
        }


      },
      //是否显示弹窗按钮
      show_button:{

        type:Boolean,
        default:false

      },
      //选择后是否自动关闭
      auto_close:{
        type:Boolean,
        default:true
        
      }

    },
    watch: {
      show(newValue, oldValue) {

        if(newValue===true){

          // this.query.p=1;

          this.getList();
        }

        this.show_ = this.show;
      },
      model(newValue, oldValue){



        this.query.search.model=newValue;

      },
      label(newValue, oldValue){



        this.query.search.label=newValue;

      },
      condition(newValue, oldValue){

        // console.log(newValue);

        // this.setCondition();
      },
      defaultCondition(newValue, oldValue){


        this.query.search.defaultCondition=newValue;

      },
      namespace(newValue, oldValue){


        this.query.search.namespace=newValue;

      }

    }

  }
</script>

<style scoped>

  .search-ma>div{

    margin-right: 20px;
    max-width: 100px;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/Alert.vue